<ion-content class="login">
  <div class="login__background"></div>
  <div class="login__content">
    <app-logo class="--big --light --desktop-dark login__content__logo" (click)="changeEnvironment()"></app-logo>
    <form class="login__content__form" [formGroup]="form" (keyup.enter)="form.valid && doLogin()">
      <ion-item class="login__content__form__item">
        <ion-label class="label" position="stacked" [innerHTML]="'E-Mail'"></ion-label>
        <ion-input
          #emailInput
          class="input"
          formControlName="username"
          placeholder="Deine E-Mail"
          inputmode="email"
          enterkeyhint="next"
          autocomplete="email"
          (keyup.enter)="passwordInput.setFocus()"
          (ionChange)="handleFormAutocomplete()"
        ></ion-input>
      </ion-item>
      <ion-item class="login__content__form__item">
        <ion-label class="label" position="stacked" [innerHTML]="'Passwort'"></ion-label>
        <ion-input
          #passwordInput
          class="input"
          formControlName="password"
          placeholder="Passwort"
          enterkeyhint="send"
          autocomplete="current-password"
          [type]="showPassword ? 'text' : 'password'"
          (ionChange)="handleFormAutocomplete()"
        ></ion-input>
        <ion-button class="input-button button --icon" fill="clear" (click)="toggleShowPassword()">
          <ion-icon [name]="showPassword ? 'eye-off' : 'eye'"></ion-icon>
        </ion-button>
      </ion-item>
      <div class="login__content__form__buttons">
        <ion-button class="button login__content__form__buttons__button" [disabled]="form.invalid" (click)="doLogin()">
          <span *ngIf="(loading$ | async) === false" [innerHTML]="'Login'"></span>
          <ion-spinner *ngIf="(loading$ | async)"></ion-spinner>
        </ion-button>
        <ion-button
          class="button --text login__content__form__buttons__button"
          [innerHTML]="'Passwort vergessen?'"
          [routerLink]="['/', routes.resetPassword]"
          [queryParams]="{ email: form.value.username }"
        ></ion-button>
        <ion-button
          *ngIf="showRegisterLink"
          class="button --text login__content__form__buttons__button"
          [innerHTML]="'neu registrieren'"
          [routerLink]="['/', routes.register]"
          [queryParams]="{ email: form.value.username }"
        ></ion-button>
        <ion-button
          class="button --text login__content__form__buttons__button"
          target="_blank"
          [innerHTML]="'Hilfe'"
          (click)="openHelp()"
        ></ion-button>
      </div>
    </form>
  </div>
</ion-content>
